<template>
  <v-app id="app" class="disable-dbl-tap-zoom">
    <vue-progress-bar></vue-progress-bar>
    <router-view></router-view>
  </v-app>
</template>

<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import globalStore from "./store.js";

export default {
  name: "App",
  mixins: [RegisterStoreModule],
  async created() {
    await this.registerStoreModule("global", globalStore);
  },
};
</script>
<style lang="scss">
@import "@/scss/variable.scss";
@import "@/scss/app.scss";

html,
body,
#app,
.v-application {
  background: #f8fafc !important;
}

.v-main,
.v-main__wrap {
  background: #f8fafc !important;
}
</style>